import { configurationConsumer } from '@tn/configs';

type TealiumEnvs = { dev?: string; qa: string; prod: string };

const TEALIUM_ENVS_FALLBACK: Record<string, TealiumEnvs> = {
    ptv: {
        dev: 'https://tm.pluto.tv/pluto-tv-web/dev/utag.js',
        qa: 'https://tm.pluto.tv/pluto-tv-web/qa/utag.js',
        prod: 'https://tm.pluto.tv/pluto-tv-web/prod/utag.js',
    },
    'pplus-us': {
        dev: 'https://tags.tiqcdn.com/utag/cbsi/pplus/dev/utag.js',
        qa: 'https://tags.tiqcdn.com/utag/cbsi/pplus/qa/utag.js',
        prod: 'https://tags.tiqcdn.com/utag/cbsi/pplus/prod/utag.js',
    },
    'pplus-intl': {
        dev: 'https://tags.tiqcdn.com/utag/cbsi/pplusintl/dev/utag.js',
        qa: 'https://tags.tiqcdn.com/utag/cbsi/pplusintl/qa/utag.js',
        prod: 'https://tags.tiqcdn.com/utag/cbsi/pplusintl/prod/utag.js',
    },
};

const resolveTealiumFallback = (region: string, lob: string): TealiumEnvs | undefined => {
    if (lob === 'pplus') {
        return region.toLowerCase() === 'us'
            ? TEALIUM_ENVS_FALLBACK['pplus-us']
            : TEALIUM_ENVS_FALLBACK['pplus-intl'];
    }
    return TEALIUM_ENVS_FALLBACK[lob];
};

async function getTealiumEnv(region: string, lob: string): Promise<string | undefined> {
    if (typeof window === 'undefined') {
        const configInstance = await configurationConsumer.getInstance({ region, lob });
        const regionJsoncConfig = configInstance.configuration;

        const tealiumEnvs =
            (regionJsoncConfig?.options?.tealiumEnvs as TealiumEnvs | undefined) ??
            resolveTealiumFallback(region, lob);

        if (tealiumEnvs) {
            switch (process.env.TEALIUM_ENV) {
                case 'dev':
                    // Fall back to qa rather than prod when a dev profile is not configured
                    return tealiumEnvs.dev ?? tealiumEnvs.qa;
                case 'qa':
                    return tealiumEnvs.qa;
                default:
                    return tealiumEnvs.prod;
            }
        }
    }
}

export { getTealiumEnv };
